module.exports = __webpack_public_path__ + "media/images/Funnel 5-e2155551e916f500fad55ac0771dbc65.png";